import { render } from "./UserPurchaseRecordView.vue?vue&type=template&id=838af836&scoped=true"
import script from "./UserPurchaseRecordView.vue?vue&type=script&lang=js"
export * from "./UserPurchaseRecordView.vue?vue&type=script&lang=js"

import "./UserPurchaseRecordView.vue?vue&type=style&index=0&id=838af836&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838af836"]])

export default __exports__